export enum DocumentTypeEnum {
    Physical = 'Physical',
    Virtual = 'Virtual',
}
